import { render, staticRenderFns } from "./PersonalInformationSettings.vue?vue&type=template&id=783bc63f"
import script from "./PersonalInformationSettings.vue?vue&type=script&lang=js"
export * from "./PersonalInformationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports